<div class="flex flex-col -m-6">

  <!-- Header -->
  <div
    class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'services.dialog.searchResources.title' | transloco }} {{ planningArea.name
      | localize }} ({{ 'services.dialog.searchResources.from' | transloco }}
      <span>{{ service.dateFrom | localizeDate: 'longDate' }} </span>
      @if (service.dateTo) {
        <span>{{ 'services.dialog.searchResources.to' | transloco | lowercase }} {{
        service.dateTo | localizeDate: 'longDate' }}</span>
      }
      <span>)</span>
    </div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>


  <!-- Content -->
  <div class="flex flex-col p-2 sm:p-8 w-full">
    <div class="flex flex-col sm:flex-row w-full">
      <div class="flex flex-col">
        <mat-form-field class="fuse-mat-no-subscript w-2/3 mb-2">
          <mat-icon matPrefix class="icon-size-5 mr-4" [svgIcon]="'heroicons_solid:search'"></mat-icon>
          <input [formControl]="searchControl"
            [placeholder]="'services.dialog.searchResources.search' | transloco" matInput type="text">
          </mat-form-field>
          @if (!controlValidDNI) {
            <mat-error class="mb-2">{{ 'services.dialog.searchResources.errorPatternDNI' |
            transloco }}</mat-error>
          }

          <mat-slide-toggle class="mb-2" [(ngModel)]="onlyNotAssociated">{{
          'services.dialog.searchResources.onlyNotAssociated' | transloco }}</mat-slide-toggle>
          <mat-slide-toggle class="mb-2" [(ngModel)]="onlyAvailable">{{
          'services.dialog.searchResources.onlyAvailable' | transloco }}</mat-slide-toggle>
          <mat-slide-toggle class="mb-2" [(ngModel)]="searchMyOdcOnly">{{
          'services.dialog.searchResources.searchMyOdcOnly' | transloco }}</mat-slide-toggle>
          <mat-slide-toggle class="mb-2" [formControl]="searchWithDNIControl" [(ngModel)]="searchWithoutHrid">{{
          'services.dialog.searchResources.searchWithDNI' | transloco }}</mat-slide-toggle>
          <mat-hint class="mb-2">{{ 'services.dialog.searchResources.hintDNI' | transloco }}</mat-hint>
        </div>
        <div class="flex flex-col w-full justify-end items-end">
          <div class="flex flex-row w-full justify-end items-end">
            <button mat-flat-button color="primary" (click)="searchResources()">{{
            'services.dialog.searchResources.search' | transloco }}</button>
          </div>
          @if (multiple) {
            <div class="flex flex-row w-full justify-end items-end pt-4">
              <button mat-raised-button color="accent" (click)="assignResources()">{{ 'apply' | transloco
              }}</button>
            </div>
          }


        </div>
      </div>

      <!-- Resources list -->
      <div class="flex flex-col mt-8 w-full">
        <p class="font-semibold mb-4">{{ 'services.dialog.searchResources.searchResult' | transloco }}</p>
        <!-- Table -->
        @if ((viewResources$ | async); as resources) {
          @if (resources.length > 0) {
            <div class="grid">
              <!-- Header -->
              <div class="sr-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5"
                matSort matSortDisableClear>
                <div class="block">{{ 'services.dialog.searchResources.id' | transloco }}</div>
                <div class="block truncate">{{ 'services.dialog.searchResources.name' | transloco }}</div>
                <div class="hidden md:block">{{ 'services.dialog.searchResources.from2' | transloco }}</div>
                <div class="hidden md:block">{{ 'services.dialog.searchResources.to2' | transloco }}</div>
                <div class="block truncate">{{ 'services.dialog.searchResources.available' | transloco }}
                </div>
                <div class="block justify-center ml-2"> Info
                </div>
                <div class="block truncate ml-2"> {{ 'services.dialog.searchResources.actions' | transloco
                  }}
                </div>
              </div>
              <!-- Rows -->
              @for (resource of resources; track trackByFn(i, resource); let i = $index) {
                <div class="sr-grid grid items-center gap-4 py-3 px-4 md:px-8 border-b">
                  <div class="flex justify-start">
                    <!-- id -->
                    {{ resource.trcodigo }}
                  </div>
                  <div class="flex justify-start">
                    <!-- name -->
                    {{ resource.name }}
                  </div>
                  <div class="hidden md:flex justify-start">
                    <!-- from -->
                    {{ resource.from | localizeDate: 'longDate'}}
                  </div>
                  <div class="hidden md:flex justify-start">
                    <!-- to -->
                    {{ resource.to | localizeDate: 'longDate'}}
                  </div>
                  <div class="flex justify-start">
                    <!-- available -->
                    {{ (resource.available === 'YES' ? 'services.dialog.searchResources.yes'
                    : 'services.dialog.searchResources.partial') | transloco }}
                  </div>
                  <!-- info -->
                  <div class="justify-start">
                    <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
                      @if (chooseMajorIcon(resource)) {
                        <button mat-icon-button color="warn"
                          (click)="toggleInfo(resource)"
                          matTooltip="{{ 'importantInformation' | transloco }}">
                          <mat-icon class="icon-size-5" [svgIcon]="chooseMajorIcon(resource)">
                          </mat-icon>
                        </button>
                      }
                      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                        [cdkConnectedOverlayOpen]="resource.showInfo">
                        <ng-container
                          *ngTemplateOutlet="infoTooltip; context: { $implicit: resource } ">
                        </ng-container>
                      </ng-template>
                    </div>
                  </div>
                  <!-- actions -->
                  <div class="justify-start">
                    @if (multiple) {
                      <button mat-raised-button color="accent"
                        (click)="toggleAssign(resource)">
                        {{ (isAssigned(resource) ? 'services.dialog.searchResources.unassign'
                        : 'services.dialog.searchResources.assign') | transloco }}
                      </button>
                    }
                    @if (!multiple && !isAssigned(resource)) {
                      <button mat-raised-button color="accent"
                        (click)="toggleAssign(resource)">
                        {{ 'services.dialog.searchResources.assign' | transloco }}
                      </button>
                    }
                  </div>
                </div>
              }
              <ng-template #infoTooltip let-res>
                <div class="flex border rounded bg-white dark:bg-slate-900">
                  <div class="flex flex-col w-100 px-6 py-4">
                    @for (alert of res.alert; track alert) {
                      <div>
                        <div class="flex flex-row">
                          <mat-icon class="icon-size-5 mr-1" [svgIcon]="chooseAlertIcon(alert)"
                          color="warn"></mat-icon>
                          <b>{{ alert.type | transloco }}</b>
                        </div>
                        <div class="flex flex-row mb-4">
                          <span>{{ alert.text | localize }} </span>
                          <br>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="flex flex-col ml-25 mt-3 mr-3">
                      <button mat-icon-button (click)="res.showInfo = false">
                        <mat-icon [svgIcon]="'mat_outline:close'"></mat-icon>
                      </button>
                    </div>
                  </div>
                </ng-template>
                <!-- Paginator -->
                <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="pageEventCallback($event)"></mat-paginator>
              </div>
            } @else {
              <div class="p-8 sm:p-16 border-t text-xl font-semibold tracking-tight text-center">
                {{ 'services.dialog.searchResources.noResources' | transloco }}
              </div>
            }
          }
        </div>
      </div>

    </div>

